import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css';
import { useToast } from '../../context/ToastContext';
import { UserContext } from '../../context/UserContext';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { login } = useContext(UserContext);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const validateForm = () => {
    let formErrors = {};
    if (!formData.email) {
      formErrors.email = 'Email zorunludur';
    }
    if (!formData.password) {
      formErrors.password = 'Şifre zorunludur';
    }
    return formErrors;
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setLoading(true);
    try {
      await login(formData.email, formData.password);
      showToast('Giriş başarılı!', 'success');
      navigate('/');
    } catch (error) {
      showToast('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container rounded-2 shadow mt-md-4 mt-0 p-4">
      <div className="login-baslik">
        <h3 className='login-title'>Giriş Yap</h3>
        <p className='fs-6 fs-7'>Giriş yaparak siparişlerinizi daha rahat takip edebilirsiniz</p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-login">
          <label>Email *</label>
          <input
            type="email"
            name="email"
            placeholder="email@gmail.com"
            value={formData.email}
            onChange={handleChange}
            required
            className={errors.email ? 'error' : ''}
          />
          {errors.email && <p className="error">{errors.email}</p>}
        </div>
        <div className="form-login">
          <label>Şifreniz *</label>
          <div className="password-input-container">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="********"
              value={formData.password}
              onChange={handleChange}
              required
              className={errors.password ? 'error' : ''}
            />
            <span
              className="login-password-toggle-icon"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? (
                <i className="fa fa-eye-slash" aria-hidden="true"></i>
              ) : (
                <i className="fa fa-eye" aria-hidden="true"></i>
              )}
            </span>
          </div>
          {errors.password && <p className="error">{errors.password}</p>}
        </div>
        <button type="submit" className="login-bttn" disabled={loading}>
          {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
        </button>
      </form>
      <div className="login-links">
        <p className='m-0 pb-1'>Henüz bir hesabınız yok mu? <Link to="/register">Kayıt Ol</Link></p>
        <p>Şifrenizi mi Unuttunuz? <Link to="/forgotpassword">Şifremi Sıfırla</Link></p>
      </div>
    </div>
  );
};

export default Login;